var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnboardingTaskTitle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.82051 3.53846C6.11246 3.53846 5.53846 4.11246 5.53846 4.82051V19.1795C5.53846 19.8875 6.11246 20.4615 6.82051 20.4615H17.0769C17.785 20.4615 18.359 19.8875 18.359 19.1795V9.34791C18.359 9.27991 18.332 9.21469 18.2839 9.1666L12.7308 3.61356C12.6827 3.56548 12.6175 3.53846 12.5495 3.53846H6.82051ZM4 4.82051C4 3.26279 5.26279 2 6.82051 2H12.5495C13.0256 2 13.4821 2.1891 13.8187 2.52571L19.3717 8.07875C19.7083 8.41535 19.8974 8.87188 19.8974 9.34791V19.1795C19.8974 20.7372 18.6347 22 17.0769 22H6.82051C5.26279 22 4 20.7372 4 19.1795V4.82051ZM8.10256 12C8.10256 11.5752 8.44696 11.2308 8.8718 11.2308H15.0256C15.4505 11.2308 15.7949 11.5752 15.7949 12C15.7949 12.4248 15.4505 12.7692 15.0256 12.7692H8.8718C8.44696 12.7692 8.10256 12.4248 8.10256 12ZM8.10256 16.1026C8.10256 15.6777 8.44696 15.3333 8.8718 15.3333H15.0256C15.4505 15.3333 15.7949 15.6777 15.7949 16.1026C15.7949 16.5274 15.4505 16.8718 15.0256 16.8718H8.8718C8.44696 16.8718 8.10256 16.5274 8.10256 16.1026Z",
    fill: "#393B46"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardingTaskTitle);
export default __webpack_public_path__ + "static/media/onboarding-task-title.73cc5f97e2b0c12ada8469ddf08a0900.svg";
export { ForwardRef as ReactComponent };